import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowRight, FileUp, Route as RouteIcon } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { IMPORT_TYPES, importTypeDescription, importTypeTitle } from '@/lib/imports';
import { useT } from '@/lib/i18n';

export const Route = createFileRoute('/settings/import/')({ component: ImportData });

/** Wizards from document 12 that live with the move from QuickBooks and with banking. */
const MORE = [
  { key: 'openingBalances', to: '/settings/migration/opening-balances' },
  { key: 'openInvoices', to: '/settings/migration/open-items/receivable' },
  { key: 'unpaidBills', to: '/settings/migration/open-items/payable' },
  { key: 'bankStatement', to: '/banking/import' },
] as const;

/** Screen G4 (document 06): Settings › Import data. */
function ImportData() {
  const t = useT();
  return (
    <>
      <PageHeader
        title={t('settingsPages.data.importHub.title')}
        description={t('settingsPages.data.importHub.description')}
      />
      <div className="flex max-w-4xl flex-col gap-4">
        <Link
          to="/settings/migration"
          className="flex items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4 hover:border-primary hover:shadow-sm"
        >
          <RouteIcon className="size-5 shrink-0 text-primary" />
          <div className="flex-1">
            <div className="font-medium">{t('settingsPages.data.importHub.moveTitle')}</div>
            <div className="text-sm text-muted-foreground">
              {t('settingsPages.data.importHub.moveDescription')}
            </div>
          </div>
          <ArrowRight className="rtl:-scale-x-100 size-4 text-primary" />
        </Link>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {IMPORT_TYPES.map((x) => (
            <Link
              key={x.kind}
              to="/settings/import/$kind"
              params={{ kind: x.kind }}
              className="flex gap-3 rounded-lg border bg-card p-4 hover:border-primary hover:shadow-sm"
            >
              <FileUp className="mt-0.5 size-5 shrink-0 text-primary" />
              <div>
                <div className="font-medium">{importTypeTitle(x.kind)}</div>
                <div className="text-sm text-muted-foreground">{importTypeDescription(x.kind)}</div>
              </div>
            </Link>
          ))}
          {MORE.map((x) => (
            <Link
              key={x.key}
              to={x.to}
              className="flex gap-3 rounded-lg border bg-card p-4 hover:border-primary hover:shadow-sm"
            >
              <FileUp className="mt-0.5 size-5 shrink-0 text-primary" />
              <div>
                <div className="font-medium">
                  {t(`settingsPages.data.importHub.more.${x.key}.title`)}
                </div>
                <div className="text-sm text-muted-foreground">
                  {t(`settingsPages.data.importHub.more.${x.key}.description`)}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
